/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
function DokanInputField({ inputValue, inputHandle, inputIndex, inputName, inputLabel = '' }) {
    return (
        <>
            <div className="input-float">
                <input
                    type="text"
                    className="pl-2"
                    value={inputValue || ''}
                    onChange={(e) => inputHandle(inputIndex, e, inputName)}
                />
                <label>{inputLabel}</label>
            </div>
        </>
    );
}
export default DokanInputField;
